import * as React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';

import css from './availability-empty.css';


export const AvailabilityEmpty = () => {
  const {t} = useLabelTranslation();
  return (
    <EmptyState
      classNames={{wrapper: css.availabilityEmpty}}
      imageVariant="calendar"
      title={t(
        'No_available_date_time_found',
        'No available date & time found',
      )}
    />
  );
};
